import {
	Grid,
	Typography,
	Divider as MuiDivider
} from "@material-ui/core"

import React from "react"
import { useParams } from "react-router-dom"
import Breadcrumb from "@/components/BreadcrumbNew"
import useStyles from "@/pages/Admin/Settings/InboxChannel/styles"
import SendMessagesTimeLimits from "@/pages/Admin/Settings/InboxChannel/SendMessagesTimeLimits/index"
import SendMessagesTimeDelay from "@/pages/Admin/Settings/InboxChannel/SendMessagesTimeDelay/index"
import { useGlobalStateStore } from "@/store/GlobalState"
import { ChannelType } from "@/protocols/channel"

type InboxChannelSettingsParams = {
	inboxChannelId: string
}

const InboxChannelSettings = () => {
	const classes = useStyles()
	const { inboxChannelId } = useParams<InboxChannelSettingsParams>()

	const globalStateStore = useGlobalStateStore()

	const currentChannel = globalStateStore.instance.current_channel_type
	const isWabaChannel = currentChannel === "waba"

	const getSendMessagesTimeLimitsDescription = () => {
		const timeLimitDescriptionsByChannel: Record<ChannelType, string> = {
			waba: "Os horários definidos abaixo são válidos somente para mensagens enviadas via Plugins e Soneca.",
			whatsapp: "Os horários definidos abaixo são válidos somente para mensagens enviadas via Integração, Envio em Massa, Plugins e Soneca."
		}

		if (!currentChannel) return

		return timeLimitDescriptionsByChannel[currentChannel]
	}

	return (
		<Grid container direction="column" spacing={2}>
			<Grid item>
				<Breadcrumb
					data={[{ name: "Configurações do Canal", pathname: `/admin/settings/inbox-channel/${inboxChannelId}` }]}
				/>
			</Grid>

			<Grid item>
				<Typography variant="h5">
					Configurações do canal
				</Typography>
			</Grid>

			<Grid item>
				<MuiDivider orientation="horizontal" />
			</Grid>

			<Grid item>
				<Typography variant="h1" className={classes.subtitleText}>
					HORÁRIOS DE ENVIO DAS MENSAGENS AUTOMÁTICAS
				</Typography>
				<Typography>
					{getSendMessagesTimeLimitsDescription()}
				</Typography>
				<Typography>
					Mensagens enviadas pelo Inbox e Chatbot não possuem limitações.
				</Typography>
			</Grid>

			<Grid item>
				<SendMessagesTimeLimits />
			</Grid>

			{
				!isWabaChannel && (
					<Grid item>
						<SendMessagesTimeDelay />
					</Grid>
				)
			}
		</Grid>
	)
}

export default InboxChannelSettings
